import { useCallback, useEffect, useState } from 'react';
import { useMarketDayContext } from './MarketPeriodsContext';
import { MarketPeriodInterface } from 'features/dispatcher/dispatcherTypes';
import { getCurrentMarketDay, validateMarketDayValueFormat } from './marketDay';
import { useMarketDayMilestonesTrackingListener } from 'utils/marketDayMilestonesTracking/useMarketDayMilestonesTrackingListener';

// ===============================|| HOOK ||=============================== //

export const useMarketPeriods = (initialMarketDay?: string) => {
  const { getMarketPeriodsForMarketDay } = useMarketDayContext();

  const [selectedMarketDay, setSelectedMarketDay] = useState<string>();
  const [marketPeriodsForMarketDay, setMarketPeriodsForMarketDay] =
    useState<MarketPeriodInterface[]>();
  const [marketHoursForMarketDay, setMarketHoursForMarketDay] =
    useState<MarketPeriodInterface[]>();
  const [isLoading, setIsLoading] = useState(false);

  const setMarketDay = useCallback((marketDay: string) => {
    if (!validateMarketDayValueFormat(marketDay)) {
      logInvalidMarketDayFormat(marketDay);
      return;
    }
    setSelectedMarketDay(marketDay);
  }, []);

  useEffect(() => {
    setMarketDay(initialMarketDay ?? getCurrentMarketDay());
  }, [initialMarketDay, setMarketDay]);

  useMarketDayMilestonesTrackingListener({
    onDayChanged: (detail) => setMarketDay(detail.currentMarketDay)
  });

  useEffect(() => {
    if (!selectedMarketDay) return undefined;
    setIsLoading(true);
    getMarketPeriodsForMarketDay(selectedMarketDay).then((marketPeriods) => {
      setMarketPeriodsForMarketDay(marketPeriods?.marketPeriods);
      setMarketHoursForMarketDay(marketPeriods?.marketHours);
      setIsLoading(false);
    });
  }, [getMarketPeriodsForMarketDay, selectedMarketDay]);

  return {
    marketPeriodsForMarketDay,
    marketHoursForMarketDay,
    setMarketDay,
    isLoading
  };
};

const logInvalidMarketDayFormat = (marketDay: string) => {
  // eslint-disable-next-line no-console
  console.warn(
    `Invalid format for market day: ${JSON.stringify(
      marketDay
    )}, expected format "YYYY-MM-DD"`
  );
};
